import { render } from "./DeleteItemForm.vue?vue&type=template&id=1f72f00a&scoped=true"
import script from "./DeleteItemForm.vue?vue&type=script&lang=js"
export * from "./DeleteItemForm.vue?vue&type=script&lang=js"

import "./DeleteItemForm.vue?vue&type=style&index=0&id=1f72f00a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f72f00a"]])

export default __exports__